export default __webpack_public_path__ + "static/media/sl_z_072523_61700_01.e4ac3a94.jpg";